const DiaryDetails = {
  'id': 'DiaryDetails',
  'layout': {
    'rows': 1,
    'columns': 1
  },
  'fields': [
    {
      'id': '1',
      'type': 'PAPER_CONTAINER',
      'props': {
        'name': 'DiaryDetails',
        'fullWidth': true
      },
      'position': {
        'row': 1,
        'col': 1,
        'colspan': 2
      },
      'children': [
        {
          id: 1,
          type: 'DIARY_DETAILS',
          props: {
            label: 'SalesInvoiceDiary',
            name: 'DiaryDetails',
            createApi: '/SalesInvoiceEnquiry/SalesInvoice/<InvoiceNumber>/Entity/<SalesEntity>/CreateDiary',
            searchByIdApi: '/SalesInvoiceEnquiry/SalesInvoice/<InvoiceNumber>/Entity/<SalesEntity>/Diary/<DiaryId>',
            updateApi: '/SalesInvoiceEnquiry/SalesInvoice/<InvoiceNumber>/Entity/<SalesEntity>/Diary/<DiaryId>',
            deleteApi: '/SalesInvoiceEnquiry/SalesInvoice/<InvoiceNumber>/Entity/<SalesEntity>/Diary/<DiaryId>'
          }
        }
      ]
    }
  ]
}
export default DiaryDetails
